export default function luhnAlgorithm(cardNumber) {
  const numberStr = cardNumber.replace(/\s/g, '');

  const numbers = numberStr.split('').map(Number);
  const check = numbers
    .reverse()
    .reduce((sum, number, index) => {
      if ((index + 1) % 2 !== 0) {
        return sum + number;
      }

      let even = number * 2;

      if (even > 9) {
        even -= 9;
      }

      return sum + even;
    }, 0);

  return check % 10 === 0;
}
